{
  "instances": {
    "quartz": {
      "actions": "操作",
      "active_triggers": "活跃触发器",
      "associated_triggers": "关联的触发器",
      "associated_with_calendar": "与日历关联",
      "basic_information": "基本信息",
      "calendar": "日历",
      "class": "类",
      "configuration": "配置",
      "cron_expression": "Cron 表达式",
      "custom_trigger": "自定义触发器",
      "days_of_week": "星期几",
      "description": "描述",
      "details": "详情",
      "disabled": "禁用",
      "durable": "持久的",
      "enabled": "启用",
      "end_time": "结束时间",
      "final_fire_time": "最终执行时间",
      "friday": "星期五",
      "group": "组",
      "infinite": "无限",
      "interval": "间隔",
      "job_data": "作业数据",
      "job_name": "作业名称",
      "jobs": "作业",
      "key": "键",
      "label": "Quartz",
      "last_fire": "最后一次触发",
      "last_fire_time": "最后一次执行时间",
      "monday": "星期一",
      "name": "名称",
      "next_fire": "下一次触发",
      "next_fire_time": "下一次执行时间",
      "no": "否",
      "no_data": "没有可用的 Quartz 信息",
      "paused_triggers": "暂停的触发器",
      "preserve_hour_of_day": "保留当天小时",
      "priority": "优先级",
      "recovery": "恢复",
      "repeat_count": "重复次数",
      "request_recovery": "请求恢复",
      "saturday": "星期六",
      "schedule_configuration": "日程配置",
      "skip_day_if_hour_does_not_exist": "如果小时不存在，跳过该天",
      "start_time": "开始时间",
      "state": "状态",
      "sunday": "星期日",
      "system_default": "系统默认",
      "thursday": "星期四",
      "time_window": "时间窗口",
      "time_zone": "时区",
      "times_triggered": "执行次数",
      "timing_information": "时间信息",
      "total": "总计",
      "trigger_data": "触发器数据",
      "trigger_failed": "触发失败",
      "trigger_failed_message": "触发任务失败: {error}",
      "trigger_failed_notification": "触发任务 \"{jobName}\" 失败: {error}",
      "trigger_fire_times": "触发时间",
      "trigger_job_now": "立即执行作业",
      "trigger_success_message": "任务 \"{jobName}\" 已成功触发",
      "trigger_success_title": "任务已触发",
      "triggers": "触发器",
      "tuesday": "星期二",
      "type": "类型",
      "value": "值",
      "wednesday": "星期三",
      "yes": "是"
    }
  }
}
